import React, { Fragment, useState, useEffect } from 'react';
import ContactSection from '../../components/ContactSection';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/music-icon.svg'
import bImg1 from '../../images/hero/contact-img.png'
import bImg2 from '../../images/shape/brd_shape.png'
import { useLocation } from 'react-router-dom';
import tawkManager from '../../utils/tawkManager';

const ContactPage = (props) => {
    const [activeTab, setActiveTab] = useState('contact');
    const location = useLocation();

    // Load Tawk.to script when chat tab is active
    useEffect(() => {
        if (activeTab === 'chat') {
            // Load the Tawk.to script
            tawkManager.loadScript()
                .then(() => {
                    console.log('Tawk.to script loaded successfully');
                })
                .catch((error) => {
                    console.error('Failed to load Tawk.to script:', error);
                });
        } else {
            // Hide widget when switching away from chat tab
            tawkManager.hideWidget();
        }

        // Cleanup function
        return () => {
            // Hide widget when component unmounts
            if (activeTab === 'chat') {
                tawkManager.hideWidget();
            }
        };
    }, [activeTab]);

    // Handle page visibility changes
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden && activeTab === 'chat') {
                // Hide widget when tab is not visible
                tawkManager.hideWidget();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [activeTab]);

    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title  pt-120  md:pt-30 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap pt-3 pb-5">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-12 text-center">
                                    <div className="page-title-box">
                                        <h2 className="title ">Contact Us</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Tabs Navigation */}
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="contact-tabs mb-4">
                                <div className="d-flex justify-content-center gap-3 flex-wrap">
                                    <button
                                        className={`btn-tab ${activeTab === 'contact' ? 'btn-active' : ''}`}
                                        onClick={() => setActiveTab('contact')}
                                    >
                                        Send us a message
                                    </button>
                                    <button
                                        className={`btn-tab ${activeTab === 'callback' ? 'btn-active' : ''}`}
                                        onClick={() => setActiveTab('callback')}
                                    >
                                        Request Call Back
                                    </button>
                                    <button
                                        className={`btn-tab ${activeTab === 'chat' ? 'btn-active' : ''}`}
                                        onClick={() => setActiveTab('chat')}
                                    >
                                        Chat with Us
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tab Content */}
                <div className="tab-content">
                    <div className={`tab-pane fade ${activeTab === 'contact' ? 'show active' : ''}`}>
                        <ContactSection activeTab="contact" />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'callback' ? 'show active' : ''}`}>
                        <ContactSection activeTab="callback" />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'chat' ? 'show active' : ''}`}>
                        <ContactSection activeTab="chat" />
                    </div>
                </div>

                <CtaSection />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;